// firekultur-section-classifier.js
// Scans sections for data-printable attributes and dispatches SectionPrintability event

document.addEventListener('DOMContentLoaded', () => {
  console.log('firekultur-section-classifier.js: Script loaded and DOMContentLoaded event fired');

  // Target only section root elements with data-printable
  const sections = document.querySelectorAll('[data-printable][data-section-id], [data-printable].section');
  const sectionPrintability = {};

  if (sections.length === 0) {
    console.log('firekultur-section-classifier.js: No sections with data-printable attribute found.');
  } else {
    sections.forEach(section => {
      // Use id as the primary identifier, fall back to data-section-id or className
      const sectionId = section.id || section.dataset.sectionId || section.className || `unnamed-section-${Math.random().toString(36).substr(2, 9)}`;
      const isPrintable = section.dataset.printable !== 'false'; // Default to true if not explicitly false
      sectionPrintability[sectionId] = isPrintable;

      const tagName = section.tagName.toLowerCase();
      const parentClass = section.parentElement ? section.parentElement.className : 'no-parent';
      console.log(`firekultur-section-classifier.js: Section ${sectionId} (tag: ${tagName}, parent: ${parentClass}) is ${isPrintable ? 'Printable' : 'Not Printable'} (data-printable="${section.dataset.printable}")`);
    });
  }

  // Dispatch SectionPrintability event with the printability status of all sections
  document.dispatchEvent(new CustomEvent('SectionPrintability', { detail: { sections: sectionPrintability } }));
  console.log('firekultur-section-classifier.js: Dispatched SectionPrintability event', sectionPrintability);
});